// extracted by mini-css-extract-plugin
module.exports = {"customButton":"CustomButton_customButton__1RQcM"};